/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const e={isAlongLine:0,isAbsoluteSize:1,isDiscrete:2};export{e as bitset};
